import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalTitle,
} from '@cambridgeassessment/cambridge-ui';
import { Box, Typography } from '@material-ui/core';
import React from 'react';
import { useStyles } from './styles';

type Props = {
  open: boolean;
  message: string;
  title: string;
  onCancel: () => void;
  onProceed: () => void;
  isError: boolean;
};

const OrgSshUserDialog: React.FC<Props> = ({
  open,
  message,
  title,
  onCancel,
  onProceed,
  isError,
}) => {
  const classes = useStyles();

  return (
    <Modal
      open={open}
      size="small"
      onClose={onCancel}
      data-testid="proceed-modal"
    >
      <Box className={classes.modalTitle}>
        <ModalTitle onClose={onCancel} data-testid="proceed-header">
          {title}
        </ModalTitle>
      </Box>
      <ModalContent>
        <Typography
          variant="body1"
          className={classes.modalText}
          data-testid="proceed-body"
        >
          {message}
        </Typography>
      </ModalContent>
      <ModalActions>
        <Button
          onClick={onCancel}
          color="primary"
          variant="text"
          data-testid="cancel-proceed-modal"
        >
          Cancel
        </Button>
        {!isError && (
          <Button
            onClick={onProceed}
            color="primary"
            variant="contained"
            data-testid="confirm-proceed-modal"
          >
            Proceed
          </Button>
        )}
      </ModalActions>
    </Modal>
  );
};

export default OrgSshUserDialog;
